import { render, staticRenderFns } from "./FormAlert.vue?vue&type=template&id=5b6c9564&scoped=true&"
import script from "./FormAlert.vue?vue&type=script&lang=js&"
export * from "./FormAlert.vue?vue&type=script&lang=js&"
import style0 from "./FormAlert.vue?vue&type=style&index=0&id=5b6c9564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c9564",
  null
  
)

export default component.exports